import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import ProgressBar from "@projModules/ProgressBar";
export default class ArticleSwiper {
    constructor(element) {
        var _a, _b;
        this.element = element;
        this.swiper = null;
        this.swiperEl = (_a = this.element.querySelector(".swiper")) !== null && _a !== void 0 ? _a : document.createElement("div");
        this.progress = new ProgressBar((_b = this.element.querySelector(".swiper-progress")) !== null && _b !== void 0 ? _b : document.createElement("div"));
        this.init();
    }
    init() {
        this.swiper = new Swiper(this.swiperEl, {
            allowTouchMove: true,
            modules: [Navigation],
            navigation: {
                nextEl: this.element.querySelector(".swiper-button-next"),
                prevEl: this.element.querySelector(".swiper-button-prev"),
            },
            spaceBetween: 20,
            on: {
                init: (swiper) => {
                    this.progress.updateTotalSegments(swiper.slides.length);
                    this.progress.resetLineWidth();
                    this.progress.handleSwiperChange(0);
                },
                slideChange: (swiper) => {
                    const direction = (swiper.activeIndex > swiper.previousIndex || swiper.activeIndex === 0) ? "next" : "prev";
                    this.element.setAttribute("data-swipe-dir", direction);
                    if (swiper.activeIndex === (swiper.slides.length - 1)) {
                        this.element.classList.add("swiper-is-final-slide");
                    }
                    else {
                        this.element.classList.remove("swiper-is-final-slide");
                    }
                    this.progress.handleSwiperChange(swiper.activeIndex, direction);
                },
            },
        });
        this.element.querySelectorAll(".swiper-refresh").forEach((el) => {
            el.addEventListener("click", () => { var _a; return (_a = this.swiper) === null || _a === void 0 ? void 0 : _a.slideTo(0); });
        });
    }
}
